'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _each = require('lodash/each');

var _each2 = _interopRequireDefault(_each);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var entrophyCriteria = {
    lowerCase: {
        regex: /[a-z]/g,
        charCount: 26
    },
    upperCase: {
        regex: /[A-Z]/g,
        charCount: 26
    },
    digits: {
        regex: /[0-9]/g,
        charCount: 10
    },
    commonSpecialCharacters: {
        regex: /[\x20-\x2F]|[\x3A-\x40]|[\x5B-\x60]|[\x7B-\x7F]/g,
        charCount: 33
    },
    uncommonSpecialCharacters: {
        regex: /[\x7F-\xFF]/g,
        charCount: 129
    },
    unicodeCharacters: {
        regex: /[^\x00-\xFF]/g, // eslint-disable-line no-control-regex
        charCount: 100000
    }
};

var calcBitEntrophy = function calcBitEntrophy(charSetCount) {
    var rawEntrophy = Math.log(charSetCount) / Math.LN2;
    return Math.round(rawEntrophy * 100) / 100;
};

exports.default = function (passwordUnderTest) {
    var possibleCharOptions = 0;
    (0, _each2.default)(entrophyCriteria, function (characterSet) {
        if (passwordUnderTest.match(characterSet.regex) !== null) {
            possibleCharOptions += characterSet.charCount;
        }
    });
    return calcBitEntrophy(possibleCharOptions);
};
//# sourceMappingURL=bit-entrophy.js.map